'use strict';

angular.module('imagetrend.components')
    .controller('CopyFormModalController', ['$scope', '$uibModalInstance', 'name', 'license_id', 'license_category_id', 'Licenses', function ($scope, $uibModalInstance, name, license_id, license_category_id, Licenses) {
        $scope.settings = {};
        $scope.settings.name = name;
        $scope.settings.licenseID = license_id;
        $scope.settings.license_category_id = license_category_id;
        $scope.licenses = [];

        // Get other licenses from the same category
        Licenses.get({ license_category_id: license_category_id }).then(function (result) {
            if (result != null) {
                $scope.licenses = result;
            }
        });

        $scope.save = function () {
            $uibModalInstance.close($scope.settings);
        }
        $scope.cancel = function () {
            $uibModalInstance.close(null);
        }

    }])
;